(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jink-matter-orbit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jink-matter-orbit')) {
  customElements.define('jink-matter-orbit', class extends HTMLElement {
    connectedCallback() {
      this.life?.abort();
      this.life = new AbortController();
      const on = (target, name, fn, opts = {}) => target.addEventListener(name, fn, { ...opts, signal: this.life.signal });
      this.stage = this.querySelector('[data-orbit-stage]');
      this.nodes = [...this.querySelectorAll('[data-orbit-node]')];
      this.pause = this.querySelector('[data-orbit-pause]');
      this.detail = this.querySelector('[data-orbit-detail]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.fine = matchMedia('(hover: hover) and (pointer: fine)');
      this.angle = 0; this.frame = 0; this.last = 0; this.visible = false; this.hovered = false;
      this.paused = this.dataset.autoplay !== 'true'; this.targetX = 0; this.targetY = 0; this.x = 0; this.y = 0;
      this.duration = Math.max(20, Number(this.dataset.duration) || 60);
      this.measure = () => { this.width = this.stage.clientWidth; this.height = this.stage.clientHeight; this.paint(); };
      this.paint = () => {
        const rx = this.width * .36, ry = this.height * .36;
        this.nodes.forEach((node,i) => {
          const a = this.angle + i * Math.PI * 2 / this.nodes.length - Math.PI/2;
          node.style.setProperty('--node-x', (Math.cos(a)*rx).toFixed(2)+'px');
          node.style.setProperty('--node-y', (Math.sin(a)*ry).toFixed(2)+'px');
        });
        this.stage.style.transform = 'translate3d('+this.x.toFixed(2)+'px,'+this.y.toFixed(2)+'px,0) rotateX('+(-this.y*.28).toFixed(2)+'deg) rotateY('+(this.x*.28).toFixed(2)+'deg)';
      };
      this.canRotate = () => !this.paused && !this.motion.matches && !this.hovered && !this.nodes.includes(document.activeElement) && !this.detail.contains(document.activeElement);
      this.schedule = () => {
        if (this.frame || !this.visible || document.hidden || !this.isConnected || this.life.signal.aborted) return;
        this.frame = requestAnimationFrame(this.tick);
      };
      this.tick = (now) => {
        this.frame = 0;
        if (!this.visible || document.hidden || !this.isConnected) { this.last = 0; return; }
        const dt = this.last ? Math.min(now-this.last,50) : 0; this.last = now;
        const rotate = this.canRotate();
        if (rotate) this.angle = (this.angle + dt/1000/this.duration*Math.PI*2) % (Math.PI*2);
        this.x += (this.targetX-this.x)*.1; this.y += (this.targetY-this.y)*.1;
        this.paint();
        if (rotate || Math.abs(this.targetX-this.x)+Math.abs(this.targetY-this.y) > .05) this.schedule();
        else this.last = 0;
      };
      this.sync = () => {
        const stopped = this.paused || this.motion.matches;
        this.pause.setAttribute('aria-pressed',String(stopped));
        this.pause.setAttribute('aria-label', stopped ? this.pause.dataset.resumeLabel : this.pause.dataset.pauseLabel);
        this.pause.querySelector('[data-pause-icon]').textContent = stopped ? '▶' : 'Ⅱ';
        this.pause.disabled = this.motion.matches;
        if (this.motion.matches) { this.targetX = this.targetY = this.x = this.y = 0; this.paint(); }
        this.schedule();
      };
      on(this.pause,'click',() => { this.paused = !this.paused; this.sync(); });
      on(this,'pointermove', e => {
        if (!this.fine.matches || this.motion.matches || this.dataset.parallax !== 'true') return;
        const r = this.stage.getBoundingClientRect();
        this.targetX = Math.max(-10,Math.min(10,(e.clientX-r.left)/r.width*20-10));
        this.targetY = Math.max(-8,Math.min(8,(e.clientY-r.top)/r.height*16-8));
        this.schedule();
      }, {passive:true});
      on(this,'pointerleave',() => { this.targetX = this.targetY = 0; this.hovered = false; this.schedule(); });
      on(this,'focusout',() => { queueMicrotask(() => this.schedule()); });
      on(this.detail,'pointerenter',() => { this.hovered = true; });
      on(this.detail,'pointerleave',() => { this.hovered = false; this.schedule(); });
      this.nodes.forEach((node) => {
        on(node,'pointerenter',() => { this.hovered = true; });
        on(node,'pointerleave',() => { this.hovered = false; this.schedule(); });
        on(node,'click',() => {
          const close = node.getAttribute('aria-pressed') === 'true';
          this.nodes.forEach(n => n.setAttribute('aria-pressed',String(n===node && !close)));
          this.detail.hidden = close;
          if (!close) {
            this.querySelector('[data-orbit-title]').textContent = node.dataset.title;
            this.querySelector('[data-orbit-description]').textContent = node.dataset.description;
            this.querySelector('[data-orbit-link]').href = node.dataset.url;
          }
        });
      });
      on(this,'keydown',e => {
        if(e.key==='Escape') {
          this.detail.hidden=true; this.nodes.forEach(n=>n.setAttribute('aria-pressed','false'));
        }
      });
      on(document,'visibilitychange',() => {
        if(document.hidden) { cancelAnimationFrame(this.frame);this.frame=0;this.last=0; }
        else this.schedule();
      });
      on(this.motion,'change',this.sync);
      this.ro = new ResizeObserver(this.measure); this.ro.observe(this.stage);
      this.io = new IntersectionObserver(entries => {
        this.visible=entries[0].isIntersecting;
        if(this.visible) this.schedule();
        else {cancelAnimationFrame(this.frame);this.frame=0;this.last=0;}
      },{threshold:0});
      this.io.observe(this);
      this.measure(); this.sync();
    }
    disconnectedCallback() {
      this.life?.abort(); this.ro?.disconnect(); this.io?.disconnect(); cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
